import React, {Component} from 'react';
import './Home.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {b64toBlob, showAxiosError} from "../../util/Helpers";
import FileSaver from "file-saver";
import {Label, UncontrolledTooltip} from "reactstrap";
// import _ from "lodash";
import {validateField} from "../../common/validation";
import Maskedinput from "react-text-mask";

class CertificatePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showButton: false,
            hesCode: null,
            error: {},
            isLoading: false,
            currentUser: null,
            hasMembership: null,
            membershipStatus: "",
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: "",
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: "",
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                mezuniyetTarihi: "",
                diplomaNo: "",
                ruhsatTarihi: "",
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: false,
                uyelikAktif: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                transferTo: "",
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                }
            },
        };
        this.RightExists = this.RightExists.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    componentDidMount() {
        this.setState({currentUser: this.props.currentUser, memberInfo: this.props.currentUser.member});
    }

    RightExists(searchItem) {
        let exists = false;
        const authorities = this.props.authorities;
        for (const authority of authorities) {
            if (authority.authority.includes(searchItem)) {
                exists = true;
            }
        }
        return exists;
    }


    handleExport() {
        let self = this;
        self.setState({
            isLoading: true,
        });
        console.log("hes Kod Post: " + this.state.hesCode);
        let params = {
            url: API_BASE_URL + "/uye/health-worker-certificate/",
            method: 'post',
            data: {
                hesCode: this.state.hesCode,
                note: null
            }
        };
        request(params).then(function (response) {
            const data = response.data.substring(response.data.indexOf(',') + 1);
            let blob = b64toBlob(data, 'application/pdf;charset=utf-8');
            FileSaver.saveAs(blob, self.state.memberInfo.tcKimlikNo + "_Meslek_Mensubu_Kimlik_Sureti.pdf");
            self.setState({
                isLoading: false,
                showButton: false,
                hesCode: null
            });
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({
                isLoading: false,
            });
        });
    }


    onChangeHesCode(v) {
        let value = v.toUpperCase();
        let index = value.indexOf('_');
        if (index !== -1) {
            if (value.length && index === 12)
                this.setState({showButton: true});
            else
                this.setState({showButton: false});
        } else
            this.setState({showButton: true});

        this.setState({hesCode: value});
    }


    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    render() {

        return (
            <div className="home-container">
                {(this.state.isLoading) && <div className="loader"><LoadingIndicator/></div>}
                <div className="page-content">
                    <Label><b>HES Kodu Giriniz</b> </Label>

                    <div className={"form-group" + this.validateClass('hesCode')}>
                        <Maskedinput style={{width: 500}} className="form-control"
                                     mask={[/[A-Za-z]/, /\d/, /[A-Za-z]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                     type="text"
                                     name={"hesCode"}
                                     id={"hesCode"}
                                     inputProps={{vdata: "hesCode", vlength: '12'}}
                                     placeholder="____-____-__"
                                     onBlur={() => this.validateField({
                                         target: {
                                             id: "hesCode",
                                             dataset: {vdata: "hesCode", vlength: '11,12'},
                                             value: this.state.hesCode
                                         }
                                     })}
                                     ref={"hesCode"}
                                     value={this.state.hesCode}
                                     onChange={(e) => this.onChangeHesCode(e.target.value)}
                        />
                        {this.validateMessage('hesCode') !== "" &&
                        <UncontrolledTooltip placement="right" target={"hesCode"} delay={0}>
                            {this.validateMessage("hesCode")}
                        </UncontrolledTooltip>}
                    </div>
                    <button onClick={() => {
                        this.handleExport()
                    }}
                            className="certificate-download-button"
                            disabled={this.state.isLoading || !this.state.memberInfo.uyelikAktif || !this.state.showButton || !this.state.hesCode}
                    >MESLEK MENSUBU KİMLİK SURETİ İNDİR
                    </button>
                    <div/>
                </div>
            </div>

        );
    }

}


export default CertificatePage;



// WEBPACK FOOTER //
// ./src/page/home/CertificatePage.js